/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whatsapp_Bot_Link_FailedInputs */

const he_whatsapp_bot_link_failed = /** @type {(inputs: Whatsapp_Bot_Link_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הקישור פג תוקף או לא תקין. התחילו שוב את תהליך החיבור מהאתר.`)
};

const en_whatsapp_bot_link_failed = /** @type {(inputs: Whatsapp_Bot_Link_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has expired or is invalid. Please start the linking flow again from the website.`)
};

/**
* | output |
* | --- |
* | "This link has expired or is invalid. Please start the linking flow again from the website." |
*
* @param {Whatsapp_Bot_Link_FailedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const whatsapp_bot_link_failed = /** @type {((inputs?: Whatsapp_Bot_Link_FailedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whatsapp_Bot_Link_FailedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_whatsapp_bot_link_failed(inputs)
	return en_whatsapp_bot_link_failed(inputs)
});